import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
Vue.use(Vuex);
/**
 * Vuex store
 */
const getDefaultState = () => {
  return {
    token: null,
    user: null,
    isAuthenticated: false,
    discussionId: null,
    discussionCommentId: null,
  };
};
export default new Vuex.Store({
  strict: true,
  plugins: [createPersistedState()],
  state: getDefaultState(),
  getters: {
    getDiscussionId: (state) => {
      return state.discussionId;
    },
    getDiscussionCommentId: (state) => {
      return state.discussionCommentId;
    },
    getToken: (state) => {
      return state.token;
    },
    getUser: (state) => {
      return state.user;
    },
    isAuthenticated: (state) => {
      return state.isAuthenticated;
    },
  },
  mutations: {
    RESET: (state) => {
      Object.assign(state, getDefaultState());
    },
    setToken(state, token) {
      state.token = token;
      if (token) {
        state.isAuthenticated = true;
      } else {
        state.isAuthenticated = false;
      }
    },
    setUser(state, user) {
      state.user = user;
    },
    setDiscussionId(state, discussionId) {
      state.discussionId = discussionId;
    },
    setDiscussionCommentId(state, discussionCommentId) {
      state.discussionCommentId = discussionCommentId;
    },
  },
  actions: {
    logout: ({ commit }) => {
      commit('RESET', '');
    },

    setToken({ commit }, token) {
      commit('setToken', token);
    },

    setUser({ commit }, user) {
      commit('setUser', user);
    },
    setDiscussionId({ commit }, discussionId) {
      commit('setDiscussionId', discussionId);
    },
    setDiscussionCommentId({ commit }, discussionCommentId) {
      commit('setDiscussionCommentId', discussionCommentId);
    },
  },
});
